
<div
  :class="
    classes(
      n(),
      n('$--box'),
      n(`--${state.size}`),
      n(`--theme-${theme}--${state.type}`),
      [(disabled || disabledStyle), n('--disabled')],
      [(disabled || disabledStyle), n(`--${state.type}-disabled`)],
    )
  "
  role="button"
  :tabindex="disabled || disabledStyle ? -1 : 0"
  :aria-disabled="disabled || disabledStyle"
  @click="handleClick"
>
  <div :class="classes(n('content'))">
    <slot />
  </div>
</div>
